// extracted by mini-css-extract-plugin
export default {"container":"DinnerSection-module__container__qpQtw","text":"DinnerSection-module__text__t1Eco"};